import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=19c9cc39&scoped=true"
import script from "./ProductTable.vue?vue&type=script&lang=ts"
export * from "./ProductTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9cc39",
  null
  
)

export default component.exports